/* eslint-disable no-param-reassign */
import { createStore } from 'vuex';
import user from './modules/user';
import templates from './modules/templates';
import graphicsTemplate from './modules/graphicsTemplate';
import panAndZoom from './modules/panAndZoom';
import undoRedoPlugin from './plugins/undoRedo';

const store = createStore({
  state: () => ({
    currentIndex: 0, // for undo/redo plugin - we base save state from this
    history: [], // for undo/redo plugin
    currentSavedStateIndex: 0,
  }),
  getters: {
    getCurrentIndex: (state) => state.currentIndex,
    getCurrentSavedStateIndex: (state) => state.currentSavedStateIndex,
  },
  actions: {
    setCurrentSavedStateIndex({ commit }, payload) {
      commit('SET_CURRENT_SAVED_INDEX', payload);
    },
  },
  mutations: {
    SET_CURRENT_SAVED_INDEX(state, payload) {
      state.currentSavedStateIndex = payload;
    },
  },
  modules: {
    templates,
    user,
    graphicsTemplate,
    panAndZoom,
  },
});

// Define an array of namespaced modules to apply undo-redo functionality
const namespacedModulesToRecord = ['graphicsTemplate'];

// Apply the undoRedoPlugin to the specified namespaced modules
undoRedoPlugin(store, namespacedModulesToRecord);

export default store;
